import { useState } from "react";
import { Container } from "../../Layouts";
import UploadMap from '../UploadMap';
import { Modal, notification, Button, } from 'antd';
import { apis } from "../../../constants";
import { updateFile, uploadFile } from "../../../api/project";
import DeviceMap from './DeviceMap'
import { CONTENT_WIDTH, CONTENT_HEIGHT } from "../../../constants";

export default function ProjectMap({ project, onUpdated, setShowFileUpdateModal, showFileUpdateModal, isHistory = false }: {
    project: Project, onUpdated: () => void,
    setShowFileUpdateModal: (show: boolean) => void,
    showFileUpdateModal?: boolean,
    isHistory?: boolean,
}) {
    const [imgFile, setImgFile] = useState();
    const [uploading, setUploading] = useState(false);
    const currentFile = project.files?.[0];
    const hasFile = !!currentFile;
    const imgUrl = hasFile ? apis.getImage.replace('{filename}', currentFile.name) : '';
    return (
        <Container style={{ display: 'flex', flex: 1 }}>
            <div style={{
                width: CONTENT_WIDTH - 320,
                height: CONTENT_HEIGHT,
                overflow: 'hidden'
            }}>
                {
                    hasFile ?
                        <DeviceMap imgUrl={imgUrl} project={project} isHistory={isHistory} />
                        :
                        isHistory ? <p>暂无展会平面图</p> :
                            <p>
                                暂无展会平面图, 请<Button type='link' style={{ padding: 0 }} onClick={() => setShowFileUpdateModal(true)}>上传</Button>
                            </p>
                }
            </div>
            <Modal
                confirmLoading={uploading}
                onOk={() => {
                    if (!imgFile) return;
                    const data = new FormData();
                    data.append('file', imgFile);
                    setUploading(true)
                    if (hasFile) {
                        updateFile(String(project.projectId), currentFile.fileId, data)
                            .then(() => {
                                notification.success({ message: '上传成功' })
                                setShowFileUpdateModal(false)
                                onUpdated();
                            })
                            .catch(() => {
                                notification.error({ message: '上传失败,请重试' })
                            })
                            .finally(() => {
                                setUploading(false)
                            })
                    } else {
                        uploadFile({ projectId: String(project.projectId) }, data)
                            .then(() => {
                                notification.success({ message: '上传成功' })
                                setShowFileUpdateModal(false)
                                onUpdated();
                            })
                            .catch(() => {
                                notification.error({ message: '上传失败,请重试' })
                            })
                            .finally(() => {
                                setUploading(false)
                            })
                    }
                }}
                okButtonProps={{
                    disabled: !imgFile
                }}
                title='上传图片' open={showFileUpdateModal} onCancel={() => setShowFileUpdateModal(false)}>
                <UploadMap onFileChange={setImgFile} />
            </Modal>
        </Container>
    )
}